// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#CommonPage .badge-indicator-notifications span{background-color:var(--warning);font-size:11px;height:17px;min-width:17px}#CommonPage #header>div{width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
